export const APP_STORE_LINK = 'https://apps.apple.com/app/easytip/id1565420121';
export const GOOGLE_PLAY_LINK = 'https://play.google.com/store/apps/details?id=net.easytip.admin';
export const APP_GALLERY_LINK = 'https://appgallery.huawei.com/app/C106850865';
